import qs from 'qs';

function useQuery(): qs.ParsedQs {
  const location = window.location;
  const searchParams = qs.parse(location.search.replace('?', ''));

  return searchParams;
}

export { useQuery };
